import { i18n } from "@next-core/i18n";
import { getI18nNamespace } from "../registerAppI18n.js";
import { getV2RuntimeFromDll } from "../../getV2RuntimeFromDll.js";
function registerWidgetI18nV3(widgetId, i18nData) {
  const ns = getI18nNamespace("widget", widgetId);
  Object.entries(i18nData).forEach(_ref => {
    let [lang, resources] = _ref;
    i18n.addResourceBundle(lang, ns, resources);
  });
}
export function widgetI18nFactory(widgetId) {
  return i18n.getFixedT(null, getI18nNamespace("widget", widgetId));
}

// istanbul ignore next
function registerWidgetI18nV2Factory() {
  const v2Kit = getV2RuntimeFromDll();
  if (v2Kit) {
    return function (widgetId, i18nData) {
      return v2Kit.getRuntime().registerWidgetI18n(widgetId, i18nData);
    };
  }
}

// istanbul ignore next
export const registerWidgetI18n = registerWidgetI18nV2Factory() || registerWidgetI18nV3;
//# sourceMappingURL=WidgetI18n.js.map